import { render } from "./BoardWrite.vue?vue&type=template&id=6333f9b0"
import script from "./BoardWrite.vue?vue&type=script&lang=js"
export * from "./BoardWrite.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__